import React from 'react';

import type { ActionsPanelProps } from '~/components/AiChat/SideBarDialog/Actions/Action/ActionTypes';
import type { InvoiceAnalysisRecommendationTaskData } from '~/components/AiChat/types';
import { AI_ACTION_TYPES } from '~/components/AiChat/types';
import useCurrencyFormatter from '~/components/CurrencyFormatterContext';
import { getDateFromServerDateTime } from '~/DateTimeUtils';
import { reportErrorInProductionOrThrow } from '~/Utils';

export const InvoiceAnalysisActionInner: React.FC<ActionsPanelProps> = ({ action }) => {
  const { currencyFormatter } = useCurrencyFormatter();

  if (!action?.task_data || action?.task_data?.task_type !== AI_ACTION_TYPES.INVOICE_ANALYSIS_RECOMMENDATION) {
    reportErrorInProductionOrThrow(new Error('Invalid action task data for Invoice Analysis Recommendation'));
  }

  const taskData = action.task_data as InvoiceAnalysisRecommendationTaskData;

  const coveredAmount =
    taskData.line_items && taskData.line_items.length > 0
      ? taskData.line_items
          .filter((item) => item.coverage_decision === 'covered')
          .reduce((sum, item) => sum + ((item.covered_amount ?? item.total_price) || 0), 0)
      : 0;

  const data = [
    { label: 'Invoice number', value: taskData.invoice_number },
    { label: 'Invoice Date', value: taskData.invoice_date ? getDateFromServerDateTime(taskData.invoice_date) : null },
    { label: 'Total', value: taskData.total_amount ? currencyFormatter.format(taskData.total_amount) : null },
    { label: 'Covered', value: coveredAmount ? currencyFormatter.format(coveredAmount) : null },
  ];

  return (
    <div className="w-full rounded-lg bg-slate-200 p-8">
      <div className={`grid grid-cols-${data.length}`}>
        {data.map(({ label }) => (
          <div key={label} className="text-md text-slate-800">
            {label}
          </div>
        ))}
      </div>
      <div className={`grid grid-cols-${data.length}`}>
        {data.map(({ label, value }) => (
          <div key={label} className="text-lg">
            {value}
          </div>
        ))}
      </div>
    </div>
  );
};
